'use client';

import React from 'react';
import styled from 'styled-components';

export interface MetricsGridProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 41px;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

/**
 * MetricsGrid Component
 * 
 * A responsive grid layout for displaying metric cards.
 * 
 * @component
 * @example
 * ```tsx
 * <MetricsGrid>
 *   <MetricCardWithChange label="Sites" value={10} change={2} />
 *   <MetricCardWithChange label="Logs" value={5} change={-1} />
 * </MetricsGrid>
 * ```
 */
export const MetricsGrid: React.FC<MetricsGridProps> = ({
  children,
  className,
  style
}) => {
  return (
    <Grid className={className} style={style}>
      {children}
    </Grid>
  );
};

export default MetricsGrid;

